import type { ResponseError } from 'umi-request';
import type { I } from '@/types/project';
import { MessageError } from '@/components';
import { log } from '@/utils/log';

// 工具函数：是否在线
const isOnline = () => window.navigator.onLine;

type ErrorLogType = {
  type: string;
  name: string;
  message?: string;
  status?: number;
  url?: string;
  data?: Record<string, any>;
  params?: Record<string, any>;
  headers?: Record<string, any>;
};

// 统一处理三类错误：断网、超时
export const errorHandlerMain = (error: ResponseError): ResponseError => {
  const { type } = error || {};
  let errorMsg = '接口错误，但没有返回具体错误信息';

  if (type === 'Timeout') {
    // 处理超时
    errorMsg = '接口请求超时，请检查网络后重试';
  } else if (!isOnline()) {
    // 处理断网
    errorMsg = '断网了，请检查网络后重试';
  }

  MessageError(errorMsg);

  const errorLog: ErrorLogType = {
    type: error.type || '',
    name: error.name || '',
    message: error?.message || '',
  };
  if (error.request) {
    const { url, options } = error.request;
    errorLog.url = url;
    errorLog.data = options.data;
    errorLog.params = options.params;
    errorLog.headers = options.headers;
  }
  if (error.response) {
    const { status } = error.response;
    errorLog.status = status;
  }

  log.log('请求异常', errorLog);

  // 该回调必须要走到这一步, 前面不能 return, 保证任何时候外层都可以拿到错误信息
  throw error;
};

// 转化 response
export const errorAdaptor = () => {
  return (resData: I.ResponseStructure<any>, ctx: any) => {
    const { response } = ctx.res;
    return {
      ...response,
      success: response.ok,
      errorMessage: response.message,
    };
  };
};
